export const STATS_TABLE_COLUMN_CLASSNAMES = {
  watchlist: "z-[1] flex w-8 items-center justify-center",
  collection:
    "z-[1] grow overflow-visible rounded pl-2 w-[150px] md:w-[200px] lg:w-[250px]",
  stat: "flex w-[100px] grow justify-end font-mono md:w-[110px]",
  statCompact: "flex w-[90px] grow justify-end font-mono md:w-[100px]",
  held: "flex w-[80px] grow justify-end font-mono",
  last7Days: "w-[100px] flex justify-end",
}
